<template>
<div class="page-title">
  <h2>{{title}}</h2>
</div>

</template>

<script>
export default {
  name: "pageTitle",
  watch:{

  },
  data(){
    return{
      title:""
    }
  },
  created(){
    this.title=this.$route.name;
  }
};
</script>

<style lang="scss" scoped>
.page-title {
  height: auto;
  background: #333b54;
  padding: pxTorem(15px);
  margin-bottom: pxTorem(15px);

  h2 {
    font-size: 1.5rem;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageTitle.vue